import React from 'react';

import * as CONSTANTS from "../constants";

import IFrame from '../components/iframe';

const iframeURL = `${CONSTANTS.DOMAIN_NAME}/${CONSTANTS.CLIENT_NAME}/website/QueueingPage.aspx?resize=true`;

export default function Queue() {

    return (
        <div className='booking-pathway__container booking-pathway__iframe-queue'>
            
            <div className='booking-pathway__main-content flex'>
                <h1 className='sr-text'>Queue</h1>

                <IFrame url={iframeURL} title="Queue" hasLoader="true" />

            </div>
        </div>
    );
}